function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Brick } from "zengular";
import twig from "./gallery.twig";
import "./gallery.scss";
var Gallery = (_dec = Brick.register('gallery', twig), _dec(_class = /*#__PURE__*/function (_Brick) {
  _inherits(Gallery, _Brick);

  var _super = _createSuper(Gallery);

  function Gallery() {
    var _this;

    _classCallCheck(this, Gallery);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        _this.prev();

        event.preventDefault();
      }

      if (event.key === ' ' || event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        _this.next();

        event.preventDefault();
      }

      if (event.key === 'Escape') {
        _this.close();

        event.preventDefault();
      }
    });

    return _this;
  }

  _createClass(Gallery, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.images = JSON.parse(this.root.innerHTML);
      console.log(this.constructor.options);
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        images: this.images,
        image: this.dataset.image,
        title: this.dataset.title
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this2 = this;

      this.viewer = this.$$('viewer').node;
      var galleryItems = this.$('.gallery-item').nodes;
      this.first = galleryItems[0];
      this.last = galleryItems[galleryItems.length - 1];
      this.$().listen('click', function (event, target) {
        if (_this2.$$('gallery-item').filter('.current').node === null) _this2.$$('gallery-item').node.classList.add('current');

        _this2.open();

        event.stopPropagation();
      });
      this.$$('viewer').listen('click', function (event, target) {
        _this2.close();

        event.stopPropagation();
      });
      this.$$('gallery-item').filter(' img').listen('click', function (event) {
        _this2.next();

        event.stopPropagation();
      });
      this.$$('next').listen('click', function (event) {
        _this2.next();

        event.stopPropagation();
      });
      this.$$('prev').listen('click', function (event) {
        _this2.prev();

        event.stopPropagation();
      });
      this.root.classList.add('rendered');
    }
  }, {
    key: "open",
    value: function open() {
      if (!this.initialized) {
        this.$('.gallery-item img').each(function (element) {
          return element.setAttribute('src', element.dataset.src);
        });
        this.initialized = true;
      }

      this.viewer.classList.add('visible');
      document.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "close",
    value: function close() {
      this.viewer.classList.remove('visible');
      document.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "next",
    value: function next() {
      var item = this.$('.gallery-item.current').node;
      var next = item.nextElementSibling;
      if (next === null || !next.classList.contains('gallery-item')) next = this.first;
      next.classList.add('current');
      item.classList.remove('current');
    }
  }, {
    key: "prev",
    value: function prev() {
      var item = this.$('.gallery-item.current').node;
      var next = item.previousElementSibling;
      if (next === null || !next.classList.contains('gallery-item')) next = this.last;
      next.classList.add('current');
      item.classList.remove('current');
    }
  }]);

  return Gallery;
}(Brick)) || _class);